
import state from './enquiriesState.js'
import * as mutations from './enquiriesMutations.js'
import * as actions from './enquiriesActions.js'
import * as getters from './enquiriesGetters.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}